import { PrimitiveType, NumericType, ObjectType, ImmutableClassType, FunctionType, ArrayType } from './basic.js';
import { DateType } from './date.js';
import { AnyType } from './any.js';
export * from './any.js';
export * from './basic.js';
export * from './date.js';
export * from './owned.js';
export * from './shared.js';
const builtins = [String, Number, Boolean, Date, Object, Array, Function], metatypes = [PrimitiveType, NumericType, PrimitiveType, DateType, ObjectType, ArrayType, FunctionType];
export function getMetatype(Ctor) {
    return Ctor._metatype || resolveBuiltins(Ctor);
}
AnyType.create = (options, name) => {
    const type = options.type, AttributeCtor = options._metatype || (type ? getMetatype(type) : AnyType);
    return new AttributeCtor(name, options);
};
function resolveBuiltins(Ctor) {
    const idx = builtins.indexOf(Ctor);
    return idx < 0 ? ImmutableClassType : metatypes[idx];
}
//# sourceMappingURL=index.js.map